export interface PrimerInputArgs {
  active: boolean;
  dirty: boolean;
  error: string | null;
  errorCode: string | null;
  submitted: boolean;
  touched: boolean;
  valid: boolean;
}

export type CreditCardField = 'cardNumber' | 'expirationDate' | 'cvv';

export enum PrimerStatusReasonType {
  APPLICATION_ERROR = 'APPLICATION_ERROR',
  GATEWAY_REJECTED = 'GATEWAY_REJECTED',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
  ISSUER_DECLINED = 'ISSUER_DECLINED',
}

export enum PrimerDeclineType {
  SOFT_DECLINE = 'SOFT_DECLINE',
  HARD_DECLINE = 'HARD_DECLINE',
}

export enum PrimerStatusReasonCode {
  ERROR = 'ERROR',
  INVALID_CARD_NUMBER = 'INVALID_CARD_NUMBER',
  EXPIRED_CARD = 'EXPIRED_CARD',
  LOST_OR_STOLEN_CARD = 'LOST_OR_STOLEN_CARD',
  SUSPECTED_FRAUD = 'SUSPECTED_FRAUD',
  UNKNOWN = 'UNKNOWN',
  DECLINED = 'DECLINED',
  REFER_TO_CARD_ISSUER = 'REFER_TO_CARD_ISSUER',
  DO_NOT_HONOR = 'DO_NOT_HONOR',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  WITHDRAWAL_LIMIT_EXCEEDED = 'WITHDRAWAL_LIMIT_EXCEEDED',
  ISSUER_TEMPORARILY_UNAVAILABLE = 'ISSUER_TEMPORARILY_UNAVAILABLE',
  AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED',
}

export interface PrimerStatusReason {
  type?: PrimerStatusReasonType;
  declineType?: PrimerDeclineType;
  code?: PrimerStatusReasonCode;
  message?: string;
}

export enum PrimerPaypalMethodType {
  PAYPAL = 'PAYPAL',
  NONE = 'NONE',
}

export enum PrimerPaymentMethodType {
  GOOGLE_PAY = 'GOOGLE_PAY',
  APPLE_PAY = 'APPLE_PAY',
  PAYPAL = 'PAYPAL',
  NONE = 'NONE',
}
